import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { BreadcrumbService } from 'app/breadcrumb.service';
import { IUser } from 'app/shared/Domains/IUser';
import { AppServiceManager } from 'common/services/appServiceManager';
import { AuthService } from 'common/services/auth.service';
import { Supplier } from '../domain/supplier';
import { LanguageService } from 'app/LanguageService/Language.Service';
@Component({
  selector: 'app-supplier-listing',
  templateUrl: './supplier-listing.component.html',
  styleUrls: ['./supplier-listing.component.css']
})
export class SupplierListingComponent implements OnInit {
  role: any;
  user: IUser;
  supplier: Supplier;
  loading: boolean;
  suppliers: any[];
  sourceSuppliers: any[];
  first: number = 0;
  imgPreview: boolean = false;
  imgPreviewImg: any;

  constructor(
    private LanguageService: LanguageService,
    private messageService: MessageService,
    private breadcrumbService: BreadcrumbService,
    private route: Router,
    private appServiceManager: AppServiceManager,
    private confirmationService: ConfirmationService,

  ) {
    this.breadcrumbService.setItems([
      { label: 'Suppliers Listing' }
    ]);

  }
  setLabel(label) {
    return this.LanguageService.GetCurrentLanguage("SupplierListingComponent", label);
  }
  ngOnInit(): void {
    this.role = AuthService.getLoggedInRole();
    this.user = AuthService.getLoggedInUser();
    this.supplier = new Supplier();
    this.suppliers = [];
    this.sourceSuppliers = [];
    this.getSuppliers();

  }

  getSuppliers() {
    this.loading = true;
    this.appServiceManager.get(`suppliers/company/${this.user.company}/branch/${this.user.branch}/getAllSuppliers`).subscribe((res: any) => {
      if (res.length > 0) {
        this.suppliers = res;
        this.sourceSuppliers = res;
      } else {
        this.messageService.clear();
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
      }
      this.loading = false;
    },
      (error) => {
        this.loading = false;
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      });
  }

  searchLocal(value, type) {
    let matchedName = [];
    if (value !== null && value !== undefined && value.toString().length > 0) {
      if (value == "") {
        this.suppliers = Object.assign([], this.sourceSuppliers);
      }
      if (!value) {
        this.suppliers = Object.assign([], this.sourceSuppliers);
      }
      if (value != "") {
        if (type === "name") {
          matchedName = Object.assign([], this.sourceSuppliers).filter(
            cust => cust.name ? cust.name.toLowerCase().indexOf(value.toLowerCase()) > -1 : null);
        }

        const distinct = (value, index, self) => {
          return self.indexOf(value) === index;
        }
        const source = matchedName;
        this.suppliers = source.filter(distinct);

        if (this.suppliers.length === 0) {
          this.suppliers = [];
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
        } else {
          this.first = 0;
          if (this.suppliers.length === 1) {
            this.first = 0;
          }
          this.suppliers = [...this.suppliers];
        }
      }
    } else {
      this.suppliers = Object.assign([], this.sourceSuppliers);
      this.suppliers = [...this.suppliers];
    }
  }

  clear() {
    this.supplier = new Supplier();
    this.searchLocal("", "");
    this.first = 0;
  }

  onPageChange(event) {
    this.first = event.first;
  }

  openPhoto(imgUri) {
    this.imgPreview = true;
    this.imgPreviewImg = imgUri;
  }

  closePhotoPreview() {
    this.imgPreview = false;
    this.imgPreviewImg = "";
  }

  viewSupplier(supplier) {
    this.route.navigateByUrl('supplier/' + supplier._id);
  }

  deleteSupplier(supplier) {
    this.confirmationService.confirm({
      message: "Are you sure you want to Delete ?",
      accept: () => {
        this.loading = true;
        let data = {
          modifiedBy: this.user._id
        };
        this.appServiceManager.put('suppliers/deleteSupplier/' + supplier._id, data).subscribe((res: any) => {
          if (res.status === true) {
            this.DeleteSupplier(supplier);
            this.messageService.clear();
            this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Successfully Deleted' });
          } else {
            this.messageService.clear();
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
          }
          this.loading = false;
          this.suppliers = [...this.suppliers]
        },
          (error) => {
            this.loading = false;
            this.messageService.clear();
            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
          });
      }
    });
  }

  DeleteSupplier(supplier) {
    let suppliers = [...this.suppliers];
    let index = this.suppliers.indexOf(supplier);
    if (index > -1) {
      suppliers.splice(index, 1);
      return this.suppliers = suppliers;
    }
  }


}
